import { get } from 'lodash';

export default (value) =>
  value ? get(value.toString().split('.')[1], 'length', 0) : 0;
